<app-alert></app-alert>
<section class="card">
  <div class="card-header">
    <span *ngIf="restrictTabflag" class="cat__core__title">
      <strong id="pageTitle">Add New Issue</strong>
    </span>
    <span *ngIf="!restrictTabflag" class="cat__core__title">
      <strong id="pageTitle">Edit Issue</strong>
    </span>
    <span style="float: right">
      <!-- <a routerLink="/ncd-issues-List"> -->
        <button class="btn btn-sm btn-default pull-right btn-back" (click)="back()"type="button">
          <em class="fa fa-chevron-circle-left"></em>&nbsp;Back
        </button>
      <!-- </a> -->
    </span>
  </div>
  <div class="row">
    <div class="col-lg-12" id="newIssueTabs">
      <ul class="nav nav-tabs" role="tablist">
        <li *ngIf="issueStatus == 'save&create'" class="nav-item">
          <a class="nav-link termsheetTab active" href="javascript: void(0);" id="termsheetTab" data-toggle="tab"
            data-target="#termSheet" role="tab">Term
            Sheet</a>
        </li>
        <li *ngIf="issueStatus == 'save&create'" class="nav-item">
          <a class="nav-link" href="javascript: void(0);" id="cashFlowTab" data-toggle="tab" data-target="#cashFlow"
            role="tab">Cashflow calculations </a>
        </li>
        <li *ngIf="issueStatus == undefined || issueStatus != 'save&create'" class="nav-item">
          <a class="nav-link active" href="javascript: void(0);" data-toggle="tab" data-target="#partA" role="tab">Part
            A</a>
        </li>
        <li *ngIf="issueStatus == 'save&create'" class="nav-item">
          <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#partA" role="tab">Part
            A</a>
        </li>
        <li *ngIf="(partAForm.valid && isPartATabFilled) || issueStatus == 'save&create'" class="nav-item">
          <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#partB" role="tab">Part B</a>
        </li>

        <li *ngIf="(partAForm.valid && isPartATabFilled) || issueStatus == 'save&create'" class="nav-item">
          <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#partC" role="tab">Part C</a>
        </li>

        <li class="nav-item" *ngIf="issueStatus == 'save&create'">
          <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#additionalFieldsTab"
            role="tab">Additional Fields</a>
        </li>
        
        <li class="nav-item" *ngIf="issueStatus == 'save&create'">
          <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#alloteestab"
            role="tab">Allottees</a>
        </li>

        <li class="nav-item" *ngIf="issueStatus == 'save&create'">
          <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#uploadScreen"
            role="tab">Documents</a>
        </li>

      </ul>
      <div class="tab-content">
        <div class="tab-pane" id="partA" role="tabcard"
          [ngClass]="[issueStatus != 'save&create' ? 'tab-pane active' : 'tab-pane']">
          <form [formGroup]='partAForm' class="well" (document:click)="a.close();b.close();">
            <div class="modal-body">

              <div class="row ">
                <div class="col-md-2">
                  <label class="form-control-label">Issue Series</label>
                  <span _ngcontent-c2="" style="color: red;">*</span>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input id="issueSeries" [formControl]="partAForm.controls['issueSeries']" class="form-control"
                      required="required" (blur)="onBlurCheckIssueSeries()">
                    <div *ngIf="isIssueSeriesUnique" class="form-control-error-custom">
                      Issue Series already exist.
                    </div>
                    <div *ngIf="isIssueSeriesValid" class="form-control-error-custom">
                      Issue Series is required.
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label">Financial Year</label>
                  <span _ngcontent-c2="" style="color: red;">*</span>
                </div>
                <div class="col-md-4 form-group">
                  <div class="input-group">
                    <select class="form-control" id="projectKey" [formControl]="partAForm.controls['financialYear']"
                      style="padding:6px;" selected>
                      <option *ngFor="let financialYear of financialYears" value="{{financialYear}}">{{financialYear}}
                      </option>
                    </select>
                  </div>
                  <div
                    *ngIf="(partAForm.controls['financialYear'].hasError('required') && partAForm.controls['financialYear'].touched)"
                    class="form-control-error-custom">
                    Financial Year is required.
                  </div>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label">Minimum Application</label>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <input NcdCommaSeperatedNumber [formControl]="partAForm.controls['minApplication']"
                      class="form-control dacimalFix" style="padding:6px;" min="0" (keydown)="onlyNumber($event)" />
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="form-group">
                    <select class="form-control" [formControl]="partAForm.controls['minApplicationDropdown']"
                      style="padding:6px;" required="required">
                      <option value="" [selected]="true">Select</option>
                      <option value="lakh">Lakh</option>
                      <option value="crore">Crore</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <label class="form-control-label">Multiples</label>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <input NcdCommaSeperatedNumber [formControl]="partAForm.controls['multiples']" class="form-control"
                      (keydown)="onlyNumber($event)" required="required">
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="form-group">
                    <select class="form-control" [formControl]="partAForm.controls['multiplesDropdown']"
                      style="padding:6px;" required="required">
                      <option value="" [selected]="true">Select</option>
                      <option value="lakh">Lakh</option>
                      <option value="crore">Crore</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label">Issue size</label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input NcdCommaSeperatedNumber [formControl]="partAForm.controls['issueSize']" class="form-control"
                      (keydown)="onlyNumber($event);" required="required" (blur)="onBlurCheckIssueSize()">
                  </div>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label">Option to retain oversubscription (amount)</label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input NcdCommaSeperatedNumber [formControl]="partAForm.controls['optionToRetainOversubscription']"
                      class="form-control" (keydown)="onlyNumber($event);" (blur)="onBlurCheckRetainOversubscription()"
                      required="required">
                  </div>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label">Issue Opening Date</label>
                </div>
                <div class="col-md-4 form-group">
                  <div class="input-group" (click)="$event.stopPropagation()">
                    <input class="form-control" [formControl]="partAForm.controls['issueOpeningDate']"
                      [(ngModel)]="issueOpeningDateModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                      name="issueOpeningDate" ngbDatepicker #a="ngbDatepicker" (focus)="a.toggle();b.close();"
                      (document:click)="a.close();" (ngModelChange)="clearIssueOpeningDateErrorMessage()"
                      required="required">
                    <button class="input-group-addon" (click)="a.toggle();b.close();" type="button">
                      <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                    </button>
                  </div>
                  <span class="form-control-error-custom" id="issueOpeningDateValid"></span>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label">Issue Closing Date</label>
                </div>
                <div class="col-md-4 form-group">
                  <div class="input-group" (click)="$event.stopPropagation()">
                    <input class="form-control" [formControl]="partAForm.controls['issueClosingDate']"
                      [(ngModel)]="issueClosingDateModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                      name="issueClosingDate" ngbDatepicker #b="ngbDatepicker" (focus)="b.toggle();a.close();"
                      (document:click)="b.close();" required="required">
                    <button class="input-group-addon" (click)="b.toggle();a.close();" type="button">
                      <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                    </button>
                  </div>
                </div>

                <div class="col-md-2">
                  <label class="form-control-label">Record Date
                  </label>
                </div>
                <div class="col-md-4 form-group">
                  <input type="text" id="calculatedRecordDate" class="form-control"
                    [formControl]="partAForm.controls['calculatedRecordDate']" maxLength="2"
                    (keydown)="onlyNumber($event)" required="required">
                </div>


                <div class="col-md-2">
                  <label class="form-control-label">Interest Payment
                  </label>
                </div>
                <div class="col-md-4 form-group">
                  <div class="row">
                    <div class="col-md-4">
                      <input type="radio" id="holidayPreponed" name="radio-group" value="Yes"
                        [formControl]="partAForm.controls['isCashflowHolidayPreponed']">
                      <label for="holidayPreponed">Preponed</label>
                    </div>
                    <div class="col-md-8">
                      <input type="radio" id="holidayPostponed" name="radio-group" value="No"
                        [formControl]="partAForm.controls['isCashflowHolidayPreponed']">
                      <label for="holidayPostponed">Postponed</label>
                    </div>
                  </div>
                </div>

                <!-- DYNAMIC -->
                <div class="clearfix col-md-6" formArrayName="partAField"
                  *ngFor="let partAFields of libraryPartAFieldsArray; let i = index;">
                  <div class="row" [formGroupName]="i">
                    <div class="col-md-4">
                      <label class="form-control-label">{{partAFields.FieldName}}</label>
                      <input type="hidden" formControlName="{{'fieldName' + i}}">
                    </div>
                    <div
                      *ngIf="partAFields.InputType == 'Text' || partAFields.InputType == 'Number' || partAFields.InputType == 'NumberWithoutZero'"
                      class="col-md-8">
                      <div class="form-group">
                        <input type="hidden" formControlName="{{'inputType' + i}}">
                        <!-- TEXT -->
                        <input *ngIf="partAFields.InputType == 'Text'" class="form-control"
                          name="{{partAFields.FieldName }}" id="{{partAFields.FieldName }}"
                          value="{{partAFields.DefaultValue}}" formControlName="{{'defaultValue' + i}}"
                          required="required">
                        <!-- NUMBER -->
                        <input *ngIf="partAFields.InputType == 'Number'" type="text" class="form-control"
                          name="{{partAFields.FieldName }}" id="{{partAFields.FieldName}}" NcdCommaSeperatedNumber
                          value="{{partAFields.DefaultValue}}" (keydown)="onlyNumber($event)"
                          formControlName="{{'defaultValue' + i}}" required="required" />
                        <!-- NUMBER WITHOUT ZERO-->
                        <input *ngIf="partAFields.InputType == 'NumberWithoutZero'" type="text" class="form-control"
                          name="{{partAFields.FieldName }}" id="{{partAFields.FieldName}}" NcdCommaSeperatedNumber
                          value="{{partAFields.DefaultValue}}" (keydown)="onlyNumberWithoutZero($event)"
                          formControlName="{{'defaultValue' + i}}" required="required" />
                      </div>
                    </div>
                    <!-- DROPDOWN -->
                    <div *ngIf="partAFields.InputType == 'DropDownSelection'" class="col-md-8 form-group">
                      <select class="form-control selDROPDOWN" name="{{partAFields.FieldName}}"
                        id="{{'defaultValue' + i}}" formControlName="{{'defaultValue' + i}}" style="padding:6px;"
                        required="required">
                        <option *ngFor="let valueList of partADropdownList[i];" value="{{valueList}}">{{valueList}}
                        </option>
                      </select>
                    </div>

                    <!-- MULTI-SELECT DROPDOWN -->
                    <div *ngIf="partAFields.InputType == 'MultiSelectDropDown'" class="col-md-8 form-group">
                      <ng-select placeholder="Select" [multiple]=true [options]="partAMultiSelectDropDownList[i]"
                        formControlName="{{'defaultValue' + i}}" style="text-align:left;"
                        (selected)="getSelectedValue($event)" (deselected)="multipleDeselectedValue($event)">
                      </ng-select>
                    </div>
                  </div>
                </div>
                <!-- ------------------------------------------------------------------------ -->



                <!-- ----------------------------------------------------- -->
              </div>

              <!-- =================================== -->
              <div class="row modal-header" style="max-height: 50px;">
                <div class="col-md-9">
                  <h6 style="text-align: center"><b>For Multi-Option Cashflow Details</b> </h6>
                </div>
                <div class="col-md-3 col-sm-3 text-right">
                  <button class="btn btn-success pull-right" (click)="addNewMultiOptionBlock()"
                    class="btn btn-sm btn-primary mb-2" type="button">
                    <em class="fa fa-plus"></em>&nbsp;Add Options</button>
                </div>
              </div>

              <div class="col-md-12 clearfix panel-group panel panel-primary panel-highlighted"
                formArrayName="multiOptionFields"
                *ngFor="let MultiOptionFields of partAForm.get('multiOptionFields')['controls']; let i = index;">
                <div [formGroupName]="i">
                  <h5><b><label> Option {{i + 1}} :</label></b></h5>
                  <div class="row" style="margin-top: 5px;">
                    <div class="col-md-2">
                      <label class="form-control-label">Coupon Rate</label>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <input NcdCommaSeperatedNumber formControlName="couponRate" min=0 max=3
                          class="form-control dacimalFix" (keydown)="onlyTwoDecimal($event)" id="{{'couponRate' + i }}"
                          (blur)="onBlurCheckCouponRate(i)" step=".01" required="required">
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label class="form-control-label">Pay-In Date</label>
                    </div>
                    <div class="col-md-4 form-group">
                      <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" formControlName="payInDate" style="padding:6px;z-index: 0;"
                          id="{{'payinDate' + i }}" placeholder="dd-mm-yyyy" name="{{'payinDate' + i }}" ngbDatepicker
                          #c="ngbDatepicker" (click)="c.toggle()"
                          (ngModelChange)="checkFirstCouponDateGreaterThanPayinDate($event, i, 'payIn')"
                          required="required">
                        <button class="input-group-addon" (click)="c.toggle()" type="button">
                          <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                      </div>
                      <span class="form-control-error-custom" id="{{'payinDateValid' + i }}"></span>
                    </div>

                    <div class="col-md-2">
                      <label class="form-control-label">First Coupon Payment Date</label>
                    </div>
                    <div class="col-md-4 form-group">
                      <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" formControlName="firstCouponPaymentDate"
                          style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" id="{{'firstCouponDate' + i }}"
                          name="{{'firstCouponDate' + i }}" ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()"
                          (ngModelChange)="checkFirstCouponDateGreaterThanPayinDate($event, i, 'firstCoupon')"
                          required="required">
                        <button class="input-group-addon" (click)="d.toggle()" type="button">
                          <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                        </button>
                      </div>
                      <span class="form-control-error-custom" id="{{'firstCouponDateValid' + i }}"></span>
                    </div>

                    <div class="col-md-2">
                      <label class="form-control-label">Redemption Date/ Perpetual</label>
                    </div>
                    <div class="col-md-4 form-group">
                      <div class="row">
                        <div class="col-md-6">
                          <select class="form-control" name="{{'isPerpetual' + i}}" id="{{'isPerpetual' + i}}"
                            formControlName="isPerpetual" style="padding:6px;" (change)="selectChangeDate($event, i)"
                            required="required">
                            <option *ngFor="let date of redemptionDateFields;" value="{{date}}">
                              {{date}}
                            </option>
                          </select>
                        </div>

                        <div class="col-md-6">
                          <div class="input-group" (click)="$event.stopPropagation()">
                            <input class="form-control" formControlName="redemptionDate" id="{{'redemptionDate' + i }}"
                              style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="{{'redemptionDate' + i }}"
                              ngbDatepicker #e="ngbDatepicker" (click)="e.toggle()"
                              [disabled]="partAForm.controls.multiOptionFields.controls[i].controls.isPerpetual.value == 'Perpetual'"
                              (ngModelChange)="checkIssueOpeningDateForRedemptionDate($event, i)" required="required">
                            <button class="input-group-addon" (click)="e.toggle()" type="button"
                              id="{{'redemption' + i }}">
                              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                            </button>
                          </div>
                          <span class="form-control-error-custom" id="{{'redemptionDateValid' + i }}"></span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label class="form-control-label">Coupon Type</label>
                    </div>
                    <div class="col-md-4 form-group">
                      <div class="input-group">
                        <select class="form-control" name="{{'couponType' + i}}" id="{{'couponType' + i}}"
                          formControlName="couponType" style="padding:6px;" required="required">
                          <option *ngFor="let couponType of couponTypeList;" value="{{couponType}}">{{couponType}}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label class="form-control-label">Redemption Premium/ Discount</label>
                    </div>
                    <div class="col-md-4 form-group">
                      <div class="row">
                        <div class="col-md-6">
                          <select class="form-control" name="{{'redemptionAmountType' + i}}"
                            id="{{'redemptionAmountType' + i}}" formControlName="redemptionAmountType"
                            style="padding:6px;" (change)="selectRedemptionPremiumDiscountChange($event, i)"
                            required="required">
                            <option *ngFor="let redemptionType of redemptionTypeList;" value="{{redemptionType}}">
                              {{redemptionType}}
                            </option>
                          </select>
                        </div>

                        <div class="col-md-6">
                          <input NcdCommaSeperatedNumber class="form-control dacimalFix"
                            name="{{'premiumDiscount' + i}}" (keydown)="onlyTwoDecimal($event)"
                            id="{{'premiumDiscount' + i}}" value="" min=0 step=".01" formControlName="premiumDiscount"
                            [readonly]="partAForm.controls.multiOptionFields.value[i].redemptionAmountType == 'None'"
                            required="required">
                        </div>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label class="form-control-label">Interest Payment Frequency</label>
                    </div>
                    <div class="col-md-4 form-group">
                      <div class="input-group" (click)="$event.stopPropagation()">
                        <select class="form-control" name="{{'interestPayment' + i}}" id="{{'interestPayment' + i}}"
                          formControlName="interestPaymentFrequency" style="padding:6px;"
                          (change)="dateValidationBasedOnInterestPaymentFrequencyChange($event, i)" required="required">
                          <option *ngFor="let interestPayment of interestPaymentFrequencyList;"
                            value="{{interestPayment}}">{{interestPayment}}
                          </option>
                        </select>
                      </div>
                      <span class="form-control-error-custom" id="{{'isInterestPayFreqCompounded' + i }}"></span>
                      <span class="form-control-error-custom" id="{{'isInterestPayFreqOnMaturity' + i }}"></span>
                      <span class="form-control-error-custom" id="{{'isInterestPayFreqCoupon' + i }}"></span>
                    </div>

                    <div class="col-md-2">
                      <label class="form-control-label">Face Value</label>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <input NcdCommaSeperatedNumber formControlName="faceValue" id="{{'faceValue' + i }}"
                          class="form-control" (keydown)="onlyNumber($event)" required="required">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div *ngIf="i != 0" class="col-md-12 col-sm-12 text-right">
                      <button type="button" class="btn-sm btn btn-danger" (click)="removeMultiOptionBlock(i)">
                        <span class="icmn-bin"></span>
                      </button>
                    </div>
                  </div>

                </div>
              </div>


              <!-- ========================= -->

              <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" aria-labelledby=""
                aria-hidden="true" style="top: 50px;">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div id="alertTitle" class="modal-header"
                      style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                      Title!
                    </div>
                    <div class="modal-body">
                      <div id="alertMessage">
                        Message..
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal fade" id="clearPartAConfirmation" tabindex="-1" role="dialog" aria-labelledby=""
                aria-hidden="true" style="top: 50px;">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabelForDelete">
                        <em class="fa fa-question-circle-o mr-2"></em>&nbsp;Confirm</h5>
                      <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <em class="fa fa-times"></em>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-sm-12">
                          Are you sure you want to clear Part A details?
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-sm btn-danger" (click)="clearPartA()" data-dismiss="modal">
                        <em class="fa fa-check"></em>&nbsp;Yes
                      </button>
                      <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                        <em class="fa fa-times"></em>&nbsp;No
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="modal-footer">
              <button *ngIf="addBtn && issueStatus != 'save&create'"
                [disabled]="partAForm.valid || (partAForm.controls['issueSeries'].hasError('required') || partAForm.controls['financialYear'].hasError('required')) || disabledOnclick || updateButtonDisable"
                type="Submit" class="btn-sm btn btn-primary" (click)="checkIssueSeriesBeforeSave('save')">
                <span id="savePartA">Save</span>
              </button>
              <button *ngIf="!addBtn && !issueCreated && issueStatus != 'save&create'"
                [disabled]="partAForm.valid ||partAForm.controls['issueSeries'].hasError('required') || partAForm.controls['financialYear'].hasError('required') || disabledOnclick || updateButtonDisable"
                type="Submit" class="btn-sm btn btn-primary" (click)="updateIssue('save', update)">
                <span id="updatePartA">Update</span>
              </button>
              <button *ngIf="issueCreated || issueStatus == 'save&create'"
                [disabled]="!partAForm.valid || disabledOnclick || updateButtonDisable" type="Submit" class="btn-sm btn btn-primary"
                (click)="updateIssue('save&create', 'updateAfterCreate')">
                <span id="updatePartA">Update</span>
              </button>
              <button *ngIf="addBtn && issueStatus != 'save&create'" type="Submit" class="btn-sm btn btn-primary"
                (click)="checkIssueSeriesBeforeSave('save&create')" [disabled]="!partAForm.valid || disabledOnclick || updateButtonDisable">
                <span id="saveAndCreate">Save and Create</span>
              </button>
              <button *ngIf="!addBtn && !issueCreated && issueStatus != 'save&create'"
                [disabled]="!partAForm.valid || disabledOnclick || updateButtonDisable" type="Submit" class="btn-sm btn btn-primary"
                (click)="updateIssue('save&create' ,'update&create')">
                <span id="updateAndCreate">Update and Create</span>
              </button>
              <button *ngIf="addBtn && !issueCreated && issueStatus != 'save&create'" type="button"
                class="btn-sm btn btn-default" (click)="clearPartADetails()">
                <em class="fa fa-refresh"></em>&nbsp;Clear</button>
            </div>
          </form>
        </div>


        <!-- Tab 2 -->
        <div class="tab-pane" id="partB" role="tabcard">
          <form [formGroup]="partBForm" class="well">
            <div class="modal-body">
              <!-- DYNAMIC -->
              <div class="row">
                <div class="clearfix col-md-6" formArrayName="partBField"
                  *ngFor="let partBFields of libraryPartBFieldsArray; let i = index;">
                  <div class="row" [formGroupName]="i">
                    <div class="col-md-4">
                      <label class="form-control-label">{{partBFields.FieldName}}</label>
                      <input type="hidden" formControlName="{{'fieldName' + i}}">
                    </div>
                    <div
                      *ngIf="partBFields.InputType == 'Text' || partBFields.InputType == 'Number' || partBFields.InputType == 'NumberWithoutZero'"
                      class="col-md-8">
                      <div class="form-group">
                        <input type="hidden" formControlName="{{'inputType' + i}}">
                        <!-- TEXT -->
                        <input *ngIf="partBFields.InputType == 'Text'" class="form-control"
                          name="{{partBFields.FieldName }}" id="{{partBFields.FieldName }}"
                          value="{{partBFields.DefaultValue}}" formControlName="{{'defaultValue' + i}}"
                          required="required">
                        <!-- NUMBER -->
                        <input *ngIf="partBFields.InputType == 'Number'" type="text" class="form-control"
                          name="{{partBFields.FieldName }}" id="{{partBFields.FieldName}}"
                          value="{{partBFields.DefaultValue}}" (keyup)="fieldValueChange(i)"
                          (keydown)="onlyNumber($event)" formControlName="{{'defaultValue' + i}}" required="required" />
                        <!-- NUMBER WITHOUT ZERO-->
                        <input *ngIf="partBFields.InputType == 'NumberWithoutZero'" type="text" class="form-control"
                          name="{{partBFields.FieldName }}" id="{{partBFields.FieldName}}"
                          value="{{partBFields.DefaultValue}}" (keydown)="onlyNumberWithoutZero($event)"
                          formControlName="{{'defaultValue' + i}}" required="required" />
                      </div>
                    </div>
                    <!-- DROPDOWN -->
                    <div *ngIf="partBFields.InputType == 'DropDownSelection'" class="col-md-8 form-group">
                      <select class="form-control" name="{{partBFields.FieldName}}" id="{{'defaultValue' + i}}"
                        formControlName="{{'defaultValue' + i}}" style="padding:6px;"
                        required="required">
                        <option *ngFor="let valueList of partBDropdownList[i];" value="{{valueList}}">{{valueList}}
                        </option>
                      </select>
                    </div>

                    <!-- MULTI-SELECT DROPDOWN -->
                    <div *ngIf="partBFields.InputType == 'MultiSelectDropDown'" class="col-md-8 form-group">
                      <ng-select placeholder="Select" [multiple]=true [options]="partBMultiSelectDropDownList[i]"
                        formControlName="{{'defaultValue' + i}}" style="text-align:left;">
                      </ng-select>
                    </div>
                  </div>
                </div>
              </div>



              <div class="modal fade" id="messagePopUp1" tabindex="-1" role="dialog" aria-labelledby=""
                aria-hidden="true" style="top: 50px;">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div id="alertTitle1" class="modal-header"
                      style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                      Title!
                    </div>
                    <div class="modal-body">
                      <div id="alertMessage1">
                        Message..
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal fade" id="clearPartBConfirmation" tabindex="-1" role="dialog" aria-labelledby=""
                aria-hidden="true" style="top: 50px;">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabelForDelete">
                        <em class="fa fa-question-circle-o mr-2"></em>&nbsp;Confirm</h5>
                      <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <em class="fa fa-times"></em>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-sm-12">
                          Are you sure you want to clear Part B details?
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-sm btn-danger" (click)="clearPartB()" data-dismiss="modal">
                        <em class="fa fa-check"></em>&nbsp;Yes
                      </button>
                      <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                        <em class="fa fa-times"></em>&nbsp;No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <!-- <button *ngIf="addBtn" type="Submit" class="btn-sm btn btn-primary"
                (click)="updateIssue('save&create','update')">
                <span id="savePartBDetails">Update11</span>
              </button> -->
              <button *ngIf="!addBtn" type="Submit" class="btn-sm btn btn-primary"
                [disabled]="!partBForm.valid || disabledOnclick"
                (click)="updateIssue('save&create', 'updateAfterCreate')">
                <span id="updatePartBDetails">Update</span>
              </button>
              <button type="button" class="btn-sm btn btn-default" (click)="clearPartBDetails()">
                <em class="fa fa-refresh"></em>&nbsp;Clear</button>
            </div>
          </form>
        </div>

        <!-- Tab 3 -->
        <div class="tab-pane" id="partC" role="tabcard">
          <form [formGroup]="partCForm" class="well">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-2">
                  <label class="form-control-label">Maker</label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input [formControl]="partCForm.controls['maker']" [(ngModel)]="userId" class="form-control"
                      readonly>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <label class="form-control-label">Checker</label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <ng-select placeholder="Select Checker" class="form-control1" [(ngModel)]="checkersList"
                      [multiple]=true [options]="userList" [formControl]="partCForm.controls['checker']"
                      style="text-align:left;" (selected)="getSelectedCheckers($event)"
                      (deselected)="multipleCheckersDeselected($event)">
                    </ng-select>
                    <div
                      *ngIf="partCForm.controls['checker'].hasError('required') && partCForm.controls['checker'].touched"
                      class="form-control-error-custom">
                      Checker is required.
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <label class="form-control-label">Authoriser</label>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input [formControl]="partCForm.controls['authoriser']" class="form-control" required="required">
                  </div>
                </div>
              </div>

              <div class="modal fade" id="messagePopUp2" tabindex="-1" role="dialog" aria-labelledby=""
                aria-hidden="true" style="top: 50px;">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div id="alertTitle2" class="modal-header"
                      style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                      Title!
                    </div>
                    <div class="modal-body">
                      <div id="alertMessage2">
                        Message..
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button *ngIf="!addBtn" type="Submit" class="btn-sm btn btn-primary"
                (click)="updateIssue('save&create', 'updateAfterCreate')" [disabled]="disabledOnclick">
                <span id="updatePartCDetails">Update</span>
              </button>
            </div>
          </form>
        </div>

        <!-- Additional Fields -->
        <div class="tab-pane" id="additionalFieldsTab" role="tabcard" *ngIf="issueStatus == 'save&create'">
          <app-additional-fields-tab *ngIf="issueStatus == 'save&create'" [issueDetails]="issueDetails">
          </app-additional-fields-tab>
        </div>

        <!-- Allotees Tab -->
        <div class="tab-pane" id="alloteestab" role="tabcard">
          <app-allotees *ngIf="issueStatus == 'save&create'" [issueId]="editIssueId"></app-allotees>
        </div>

        <!-- Upload Tab -->
        <div class="tab-pane" id="uploadScreen" role="tabcard">
          <app-upload-tab *ngIf="issueStatus == 'save&create'" [issueId]="editIssueId"></app-upload-tab>
        </div>



        <!-- Additional Fields -->
        <!-- <div class="tab-pane" id="NseFieldsTab" role="tabcard" *ngIf="issueStatus == 'save&create'">
            <app-nse-fields-tab *ngIf="issueStatus == 'save&create'"></app-nse-fields-tab>
        </div> -->

        <!-- TERMSHEET -->
        <div class="tab-pane" id="termSheet" role="tabcard"
          [ngClass]="[issueStatus == 'save&create' ? 'tab-pane active' : 'tab-pane']">
          <app-termsheet *ngIf="issueStatus == 'save&create'" [issueDetails]="issueDetails"
            (showTermSheetTabActive)="termSheetTabActivate()"></app-termsheet>
        </div>

        <!-- CASHFLOW -->
        <div class="tab-pane" id="cashFlow" role="tabcard">
          <app-cashflow-calci *ngIf="issueStatus == 'save&create'" (cashFlowTabActive)="cashFlowTabActivate()"
            [issueDetails]="issueDetails"></app-cashflow-calci>
        </div>
      </div>
    </div>
  </div>
</section>